import { useState, createContext, useContext } from "react";
import Authorization from "../models/Authorization";

const AuthContext = createContext(undefined);

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider(props) {
    const [authorization, SetAuthorization] = useState<Authorization>();

    return (
        <AuthContext.Provider value={{ authorization, SetAuthorization }}>
            {props.children}
        </AuthContext.Provider>
    );
}